import config from '@/tenant/config.json'

type TenantConfig = {
    logo?: {
        dark_url?: string
        light_url?: string
    }
    favicon_url?: string
    color?: {
        light?: {
            primary?: string
        }
    }
    name?: {
        title?: string
    }
}

export const tenantConfig = config as TenantConfig
